import { render, staticRenderFns } from "./recieveaddress.vue?vue&type=template&id=2ca6d5bc"
import script from "./recieveaddress.vue?vue&type=script&lang=js"
export * from "./recieveaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports